import { StoreSlice, INullableString } from '../types';

export declare interface ITextOverlaySlice {
  currentTextOverlay: INullableString;
  setCurrentTextOverlay: (v: INullableString) => void;
}

const createTextOverlaySlice: StoreSlice<ITextOverlaySlice> = (set) => ({
  currentTextOverlay: null,
  setCurrentTextOverlay: (v) => set((state) => { state.currentTextOverlay = v; }),
});

export default createTextOverlaySlice;
